import PropTypes from "prop-types";
import React from "react";
import galleryTemplate from "templates/modules/product/product_image_gallery.jinja";
import Baustein from "web/react/components/baustein/baustein";
import ProductGallery from "web/react/components/product-gallery/product-gallery";
import { DesignerPropType } from "web/types/designer";
import { ProductPropType } from "web/types/product";
import { ProductCardPropType } from "web/types/product-card";

import "web/script/components/image-gallery";

function PDPGallery({ features, product, designer, relatedProducts }) {
    let isSwipeOnRedirect = features.pmt_221_swipe_redirect && product.images.length >= 3;
    return (
        <>
            <div className="hidden-desktop hidden-tablet-only">
                <ProductGallery
                    relatedProducts={relatedProducts}
                    dotsInsideGallery={features.uj_dots_inside_gallery}
                    images={product.images}
                    currentLinkId={product.link_ids[0]}
                    swipeRedirect={isSwipeOnRedirect}
                />
            </div>
            <Baustein
                template={galleryTemplate}
                className="hidden-mobile"
                args={{
                    modifier: "vertical-thumbnails",
                    product_image_gallery: {
                        product_id: product.product_id,
                        buy_option: null, // Always null
                        images: product.images,
                        designer: designer.name,
                        designer_link: designer.url,
                        images_count: product.images.length,
                        retailer_name: "", // Never used
                        view_similar_enabled: false, // Always false
                        current_link_id: product.link_ids[0],
                        swipe_redirect: isSwipeOnRedirect,
                    },
                }}
            />
        </>
    );
}

PDPGallery.propTypes = {
    product: ProductPropType.isRequired,
    designer: DesignerPropType.isRequired,
    features: PropTypes.object.isRequired,
    relatedProducts: PropTypes.arrayOf(ProductCardPropType),
};
export default PDPGallery;
